// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","cardContainer":"cardContainer--1kBB6","searchAsCard":"searchAsCard--HjKng","stripe":"stripe--1Ap8p","freeTag":"freeTag--DCsRR"};